var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0653 16.25V17.6562C12.0653 18.1222 11.6815 18.5 11.2081 18.5H1.49386C1.02047 18.5 0.636719 18.1222 0.636719 17.6562V4.71875C0.636719 4.25275 1.02047 3.875 1.49386 3.875H4.06529V14.2812C4.06529 15.3668 4.96247 16.25 6.06529 16.25H12.0653ZM12.0653 4.15625V0.5H6.06529C5.5919 0.5 5.20815 0.877754 5.20815 1.34375V14.2812C5.20815 14.7472 5.5919 15.125 6.06529 15.125H15.7796C16.253 15.125 16.6367 14.7472 16.6367 14.2812V5H12.9224C12.451 5 12.0653 4.62031 12.0653 4.15625ZM16.3857 3.06539L14.0306 0.747113C13.8699 0.58889 13.6519 0.500001 13.4245 0.5L13.2081 0.5V3.875H16.6367V3.66199C16.6367 3.43822 16.5464 3.22362 16.3857 3.06539Z",
    fill: "#B7C5C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9e86ba340120e416b5c80ec33038b823.svg";
export { ForwardRef as ReactComponent };